import { Link } from "react-router-dom";
import React, { useEffect, useRef } from "react";
import ProductCard from "./ProductCard";
import { useDispatch, useSelector } from "react-redux";
import { getAllProducts } from "../../redux/features/product/productSlice";
import { toast } from "react-toastify";
import Spinner from "../Spinner";
import Slider from "react-slick";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const FeatureProduct = () => {
  // const dispatch = useDispatch();
  const { isLoading, featureProducts } = useSelector((state) => state.products);

  // useEffect(() => {
  //   if (error) {
  //     toast.error(error);
  //   }

  //   dispatch(getAllProducts());
  // }, [dispatch]);

  // react-slick
  const sliderRef = useRef(null);
  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    // initialSlide: 1,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      // {
      //   breakpoint: 600,
      //   settings: {
      //     slidesToShow: 2,
      //     slidesToScroll: 1,
      //     initialSlide: 2,
      //   },
      // },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.5,
          // slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  };

  return (
    <>
      <div className="bg-slate-100 py-20 px-[10px] md:px-[20px] lg:px-[7%]">
        <div className="flex lg:flex-row  lg:items-center justify-between">
          <div>
            <h4 className="font-extrabold uppercase text-sm text-slate-600">
              You can shopping now
            </h4>
            <h1 className="text-3xl font-extrabold text-black pb-2">
              Top Rated
            </h1>
          </div>
          <div>
            <div className=" flex flex-col">
              {/* <Link
                className=" mb-1 flex justify-center  border border-black cursor-pointer  px-3 bg-slate-900 hover:bg-slate-950 text-white py-1 text-xl"
                to="/products"
              >
                See All
              </Link> */}
              <div className="hidden  lg:flex items-center">
                <div className=" grid grid-cols-2 gap-3 text-slate-600 ">
                  <button
                    onClick={() => sliderRef.current.slickPrev()}
                    className="  border border-slate-300 cursor-pointer  px-3 hover:bg-black hover:text-white hover:border-pbtn py-2 text-2xl"
                  >
                    <IoIosArrowBack />
                  </button>
                  <button
                    onClick={() => sliderRef.current.slickNext()}
                    className=" border  border-slate-300 cursor-pointer px-3 hover:bg-black hover:text-white hover:border-pbtn py-2 text-2xl "
                  >
                    <IoIosArrowForward />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className=" py-12">
          <>
            {isLoading ? (
              <h1 className=" text-center text-lg font-bold">Loading...</h1>
            ) : (
              <Slider ref={sliderRef} {...settings}>
                {featureProducts.map((p) => (
                  <ProductCard
                    key={p._id}
                    name={p.name}
                    image={p.images[0].url}
                    price={p.price}
                    id={p._id}
                    description={p.description}
                    ratings={p.ratings}
                    numOfReviews={p.numOfReviews}
                  />
                ))}
              </Slider>
            )}
          </>
        </div>
      </div>
    </>
  );
};

export default FeatureProduct;
